import { useMutation, useQueryClient, type QueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import type { TriageStatus } from '@elva/ui';
import { triageApi } from '../api/triageApi';
import type { TriageDetail } from '../api/types';

function syncAfterPatch(queryClient: QueryClient, uuid: string, detail: TriageDetail) {
  queryClient.setQueryData(keys.triage.item(uuid), detail);
  void queryClient.invalidateQueries({ queryKey: ['triage', 'list'] });
}

export function useUpdateTriageStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ uuid, status }: { uuid: string; status: TriageStatus }) =>
      triageApi.patchItem(uuid, { status }),
    onSuccess: (detail, { uuid }) => syncAfterPatch(queryClient, uuid, detail),
  });
}

/** `assigneeId` is the organization.User integer PK, or `null` to unassign. */
export function useUpdateTriageAssignee() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ uuid, assigneeId }: { uuid: string; assigneeId: number | null }) =>
      triageApi.patchItem(uuid, { assignee_id: assigneeId }),
    onSuccess: (detail, { uuid }) => syncAfterPatch(queryClient, uuid, detail),
  });
}
